import styled from "styled-components";

export const AreaInputLink = styled.div`
  width: min-content;
`;
